import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import ApplicationCard from './components/ApplicationCard';
import Header from '../Header';
import KenButton from '../../components/KenButton';
import AddIcon from '../../assets/icons/add_circle_white.svg';
import { Link, useHistory } from 'react-router-dom';
import { getApplicationById, getContactByPhone } from '../../utils/ApiService';
import KenLoader from '../../components/KenLoader/KenLoader';
import KenCard from '../../components/KenCard';
import { routes } from '../../utils/urls';
import { GLOBAL } from '../../utils/constants';
import { capitalizeFirstLetter } from '../../utils/stringHelper';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 40,
    position: 'relative',
  },
  link: {
    top: '47px',
    position: 'relative',
    right: '31px',
    float: 'right',
    textDecoration: 'none',
  },
  headingSec: {
    margin: '32px 0',
  },
  heading: {
    fontWeight: 'bold',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '25px',
  },
}));
export default function Applications() {
  const { t } = useTranslation();
  const [drafts, setDrafts] = React.useState([]);
  const [noApp, setNoApp] = React.useState(false);
  const [application, setApplication] = React.useState([]);
  const [details, setDetails] = React.useState({});
  const [loader, setLoader] = React.useState(true);
  const history = useHistory();
  const contactId = localStorage.getItem('contactID');
  const locState = useLocation().state;

  React.useEffect(() => {
    localStorage.removeItem('AppID');
    localStorage.removeItem('StudentID');

    let phone;
    phone = localStorage.getItem('userPhone');

    const signInPayload = {
      Phone: phone,
    };

    getContactByPhone(phone).then((res) => {
      setDetails({
        ...details,
        // firstName: res.data[0].FirstName,
        // lastName: res.data[0].LastName,
        // parentId: res.data[0].Id,
        // Email: res.data[0].hed__AlternateEmail__c,
        // userDetails: res.data[0],
         firstName: "Test",
        lastName: "test",
        parentId: "1",
        Email: "test@ken42.com",
        userDetails: {},

      });
    });
    getApplicationById(contactId)
      .then((res) => {
        setLoader(false);
        let obj = {};
        res?.data?.forEach((el) => {
          if (
            el.Application_Status__c ===
            capitalizeFirstLetter(GLOBAL.APPLICATION_STATUS.INCOMPLETE)
          ) {
            setDrafts((oldDraft) => [...oldDraft, el]);
          } else {
            if (!(el.Application_Status__c in obj)) {
              obj[el.Application_Status__c] = [];
            }
            obj[el.Application_Status__c].push(el);
          }
          setApplication({ ...obj });
        });
      })
      .catch((error) => {
        setLoader(false);
        setNoApp(true);
      });
  }, []);

  const handleNewApplication = () => {
    history.push({
      pathname: `${routes.programs}`,
      state: details,
    });
  };
  const classes = useStyles();
  return (
    <div>
      <Header
        title={t('titles:draft_heading')}
        isLogo={false}
        firstName={details.firstName}
        lastName={details.lastName}
      ></Header>
      {loader && <KenLoader />}

      <div className={classes.container}>
        {noApp && (
          <Grid container className={classes.applSection}>
            <Grid item justify="space-between" className={classes.headingSec}>
              <KenCard>
                <Typography>{t('labels:draft_emptyCard')}</Typography>
              </KenCard>
            </Grid>
          </Grid>
        )}

        {drafts && drafts.length > 0 && (
          <>
            <Grid container style={classes.applSection}>
              <Grid
                item
                // container
                // justify="space-between"
                className={classes.headingSec}
              >
                <Typography variant="h6" className={classes.heading}>
                  {t('labels:draft_draftTitle')}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3} xs={12}>
              {drafts.map((draft, index) => (
                <Grid item key={index}>
                  <Link
                    className="link-plain"
                    to={{
                      pathname: `${routes.instructions}${draft.Contact__c}`,
                      search: `?name=${draft.ProgramId}&year=${draft.AcademicYear}`,
                      state: {
                        applicationDetails: {
                          studentId: draft.Contact__c,
                          AppID: draft.Id,
                          ApplicationNo: draft.Application_No__c,
                          draft: true,
                        },
                        userDetails: details?.userDetails,
                        academicProgramDetails: {
                          ...draft,
                          type: draft.Type,
                          fees: draft.Fees,
                          academicProgram: draft.ApplyingTO,
                          programId: draft.ProgramId,
                          ApplicationStatus: draft.ApplicationStatus,
                          AcademicYear: draft.AcademicYear,
                        },
                        ParentId: details.parentId,
                        Email: details.Email,
                      },
                    }}
                  >
                    <ApplicationCard {...draft} index={index} />
                  </Link>
                </Grid>
              ))}
            </Grid>
          </>
        )}
        {Object.keys(application).map((el) => (
          <Grid container className={classes.applSection}>
            <Grid
              item
              container
              justify="space-between"
              className={classes.headingSec}
            >
              <Typography variant="h6" className={classes.heading}>
                {el}
              </Typography>
            </Grid>
            {/* Application Cards */}
            <Grid item container spacing={3}>
              {application &&
                application[el].map((applicationObject, index) => (
                  <Grid item>
                    <ApplicationCard {...applicationObject} index={index} />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        ))}
      </div>
    </div>
  );
}
